import { Reservation } from './../models/assignato/reservation';
import { defineStore } from 'pinia';

export const useReservationStore = defineStore('reservation', {
    state: () => ({
        reservation: null as Reservation | null
    }),
    actions: {
        setReservation(reservation: Reservation) {
            this.reservation = reservation;
        }
    }
});